import {_API, _CRUD} from "./_Action";
import {RootState} from "../reducer";
import {_CALL_API} from "../../middleware/api";
import {route} from "../../../conf/routes";

export const ACCOUNT_INFOS = 'account_infos';

export const ENTERPRISE_SELECTED = 'enterprise_selected';

export const PASSWORD_CHANGE = 'password_change';

const _ACCOUNT_INFOS = _CRUD(ACCOUNT_INFOS);

export const fetchAccountInfos = () => (dispatch, getState: () => RootState) => {
  return dispatch({
    [_CALL_API]: {
      types: [ _ACCOUNT_INFOS.GET.REQUEST, _ACCOUNT_INFOS.GET.SUCCESS, _ACCOUNT_INFOS.GET.FAILURE ],
      route: route.accountInfos.get()
    }
  })
};

export const updateAccountInfos = (data) => (dispatch, getState: () => RootState) => {
  return dispatch({
    [_CALL_API]: {
      types: [ _ACCOUNT_INFOS.UPDATE.REQUEST, _ACCOUNT_INFOS.UPDATE.SUCCESS, _ACCOUNT_INFOS.UPDATE.FAILURE ],
      route: route.accountInfos.update(data)
    }
  })
};

export const updatePassword = (newPassword) => (dispatch, getState: () => RootState) => {
  return dispatch({
    [_CALL_API]: {
      types: [ _ACCOUNT_INFOS.UPDATE.REQUEST, _ACCOUNT_INFOS.UPDATE.SUCCESS, _ACCOUNT_INFOS.UPDATE.FAILURE ],
      route: route.accountInfos.updatePassword(newPassword)
    }
  })
};

export const fetchEnterpriseSelected = (enterpriseId: string) => (dispatch, getState: () => RootState) => {
  return dispatch({
    type: ENTERPRISE_SELECTED,
    id: enterpriseId
  })
};

export const acceptCGU = (enterpriseId: string, data: any) => (dispatch, getState: () => RootState) => {
  const actions = _API('accept_cgu')
  return dispatch({
    [_CALL_API]: {
      types: [ actions.REQUEST, actions.SUCCESS, actions.FAILURE ],
      route: route.accountInfos.acceptCgu(enterpriseId, data)
    }
  })
};

export const REFEST_AFTER_CHANGE_REQUEST = 'refesh_after_change_request';
export const REFEST_AFTER_CHANGE_SUCCESS = 'refesh_after_change_success';
export const REFEST_AFTER_CHANGE_FAILURE = 'refesh_after_change_failure';

export const refeshAfterChange = () => (dispatch, getState: () => RootState) => {
  return dispatch({
    [_CALL_API]: {
      types: [ REFEST_AFTER_CHANGE_REQUEST, REFEST_AFTER_CHANGE_SUCCESS, REFEST_AFTER_CHANGE_FAILURE ],
      route: route.accountInfos.get()
    }
  })
};



// WEBPACK FOOTER //
// ./src/core/redux/action/accountInfosAction.ts